/* eslint-disable no-shadow */
// import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  discovery as state
} from '../store';

export default createReducer(state, {
  SET_DISCOVERY_DATA: (state, { data }) => ({ ...state, ...data }),
  UPDATE_DISCOVERY_DATA: (state, { data }) => ({ ...state, ...data }),
  SET_WHOLE_DISCOVERY: (state, { data }) => ({ ...state, ...data }),
});
